export { default } from "./HeroIphoneStand";
export * from "./HeroIphoneStand";
